import React, { useEffect, useState } from "react";
import { Item, ListBox, Text, ComboBox, Grid, useAsyncList } from "@adobe/react-spectrum";
import { useDependency } from "../../../../../contexts/DependencyProvider";
import { ListCityRequest } from "../../../../../services/soap/translate/reqeusts/ListCityRequest";
import { useTranslation } from "react-i18next";


export interface Character {
    id:string;
    name: string;
    city:string;
    cityName:string;
    cityId:string;
    region:string;
}

interface ICityDropDownProps{
   selectedCityId:string;
   onChange:(data:Character)=> void;
   isRequired?:any
  errorMessage?:any
  validationState?:any
}

const CityDropDown:React.FC<ICityDropDownProps> = ({selectedCityId,onChange,isRequired,
  errorMessage,
  validationState}) => {
  const { store, translateService } = useDependency();
  const [selectedKey, setSelectedKey] = useState<string | null>(null);
  const { t } = useTranslation('contacts');
  const _t = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });

  useEffect(()=>{
     list.reload();
  },[])

  const list = useAsyncList<Character>({
    async load({ cursor,filterText }) {
      const offset = cursor ? Number(cursor) : 0;
      const limit = 50;
      try {
        const request = new ListCityRequest(store.Server, store.SessionId, {
          limit,
          offset,
          ...(filterText ? { cityName: filterText } : { cityId: selectedCityId })
      });
        const response = await translateService.listCity(request);

        const cities = response?.ROWS?.ROW || [];
        if (!Array.isArray(cities)) {
          console.error("Invalid API response: Expected an array", response);
          return { items: [] };
        }
        return {
          items: cities,
          cursor: cities.length === limit ? String(offset + limit) : undefined,
        };
      } catch (error) {
        console.error("Error fetching cities:", error);
        return { items: [] };
      }
    },
  });

  
  useEffect(() => {
    if (selectedCityId) {
      setSelectedKey(selectedCityId);
      list.reload();
    } else {
      setSelectedKey(null);
    }
  }, [selectedCityId]);


  const handleSelectionChange = (key:any) => {
    setSelectedKey(key);
    if (key) {
      const selectedCity = list.items.find((x) => x.city === key);
      if (selectedCity) {
        onChange(selectedCity);
      }
    }
  };

  return (
    <ComboBox
      label={_t("city")}
      aria-label={_t("city")}
      items={list.items}
      onInputChange={list.setFilterText}
      loadingState={list.loadingState}
      onLoadMore={list.loadMore}
      selectedKey={selectedKey}
      onSelectionChange={handleSelectionChange}
      width={{base:"100%",L:'35%'}}
      isRequired={isRequired}
    errorMessage={errorMessage}
    validationState={validationState}
    > 
  {(item) => (
    <Item key={item.city} textValue={item.cityName}>
        {item.cityName}
    </Item>
  )}
</ComboBox>
  );
};

export default CityDropDown;
